import { soundToPlay, soundToStop } from '../../mechanics/sounds/sound'
import { useEffect, useState } from 'react'
import { fightSlice } from '../../store/reducers/FightReducer'
import { sceneSlice } from '../../store/reducers/SceneReducer'
import { useAppDispatch, useAppSelector } from '../../store/store'
import BaseButton from '../ui/BaseButton'
import "./Locations.scss"
import LocationsItem from './LocationsItem'

const Locations = () => {
    const dispatch = useAppDispatch()
    const { setScene, setCurrentLocation } = sceneSlice.actions
    const { clearDeadEnemies, setBackground, setDifficalty } = fightSlice.actions
    const levels = useAppSelector(state => state.SceneReducer.locations)
    const locationsIndex = useAppSelector(state => state.SceneReducer.currentLocation)
    const mainCharacter = useAppSelector(state => state.userReducer.character)

    const [index, setIndex] = useState(levels.getIndex())

    const mainClass = "Locations"

    useEffect(() => {
        mainCharacter.setHp(mainCharacter.getMaxHp())
    })

    const handleClick = (index: number) => {
        soundToStop("mainMusic")
        soundToPlay("fightMusic")
        dispatch(clearDeadEnemies())
        dispatch(setCurrentLocation(index))
        dispatch(setBackground(levels.getLocationsSet()[locationsIndex].getBackground()))
        dispatch(setScene("explore"))
        // dispatch(setDifficalty(levels[locationsIndex][index].getDifficulty()))
    }

    const backClick = () => {
        dispatch(setScene("main"))
    }

    function rightArrowClick() {
        if(levels.getIndex() === levels.getLocations().length - 1) {
            levels.setLocations()
        }
        
        levels.incIndex()
        setIndex(levels.getIndex())
    }

    function leftArrowClick() {
        if(levels.getIndex() > 0)
            levels.decIndex()
        setIndex(levels.getIndex())
    }

    return (
        <div className={mainClass}>
            <h1 className={`${mainClass}__title`}>Game locations: {index + 1}</h1>
            <div className={`${mainClass}__body`}>
                {levels.getIndex() === 0 ?
                    <div className="arrow-hover move-left location-arrow">
                        <div style={{display: "none"}}></div>
                    </div> : 
                    <div className="arrow-hover move-left location-arrow" onClick={leftArrowClick}>
                        <div></div>
                    </div>}
                <div className={`${mainClass}__modal`}>
                    {levels.getLocationsSet().map((item, i) => {
                        return (
                            <LocationsItem key={i} mainClass={mainClass} handleClick={() => handleClick(i)} location={item} />
                        )
                    })}
                </div>
                <div className="arrow-hover move-right location-arrow" onClick={rightArrowClick}>
                    <div></div>
                </div>
            </div>
            <BaseButton name="Back" onClick={backClick} />
        </div>
    )
}

export default Locations;